import React from "react";
import Chart from "react-apexcharts";

const PincodeBubbleChart = ({ data = [] }) => {

  const chartData = (data || [])
    .filter(item => item.pincode)   // remove null pincodes
    .map((item) => ({
      x: String(item.pincode),      // force string
      y: Number(item.bookingcount) || 0,
    }));

  const series = [
    {
      name: "Bookings",
      data: chartData,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      background: "#111111",
      toolbar: { show: false },
      zoom: {
        enabled: false   // 🔥 disable scroll zoom
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 4,
      }
    },
    theme: { mode: "dark" },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "category",
      labels: {
        style: { colors: "#FFFFFF" },
      },
      title: {
        text: "Pincode",
        style: { color: "#FFFFFF" },
      },
    },
    yaxis: {
      labels: {
        style: { colors: "#FFFFFF" },
      },
      title: {
        text: "Booking Count",
        style: { color: "#FFFFFF" },
      },
    },
    fill: {
      opacity: 0.8,
      colors: ["#FBB033"]
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const data = w.config.series[seriesIndex].data[dataPointIndex];

        return `
          <div style="padding:8px;">
            <strong>Pincode:</strong> ${data.x}<br/>
            <strong>Bookings:</strong> ${data.y}
          </div>
        `;
      }
    }
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={500}
    />
  );
};

export default PincodeBubbleChart;